import classNames from 'classnames';
import React from 'react';

import * as hoverStyles from '../Card/CardHover.css';
import * as styles from './ControlWrapper.css';

interface IControlWrapperProps {
  visible?: boolean;
}

export const ControlWrapper: React.FC<IControlWrapperProps> = ({ children, visible }) => {
  return (
    <div className={styles['cont']}>
      <div className={classNames(styles['inner'], hoverStyles['controls'], visible && styles['visible'])}>
        {children}
      </div>
    </div>
  );
};
